import React from "react";
import { Typography, makeStyles, Grid } from "@material-ui/core";
import { Fade } from "react-awesome-reveal";

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: "100%"
  },
  headerText: {
    color: "white"
  },
  strikethrough: {
    textDecoration: "line-through"
  }
}));

const HeaderText = () => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justify="center"
      className={classes.wrapper}
    >
      <Fade direction="bottom" triggerOnce={true}>
        <Typography variant="h1" className={classes.headerText}>
          Recruiter Type Test
        </Typography>

        <Typography variant="body1" className={classes.headerText}>
          This typing game will{" "}
          <span className={classes.strikethrough}>brainwash you</span> teach you
          about me as a developer!
        </Typography>
      </Fade>
    </Grid>
  );
};

export default HeaderText;
